// CardItem.js
// CardItem.js
// CardItem.js
import React from "react";
import cardImg from "../images/mastercard.png"; // Adjust path as needed
import cardImgVisa from "../images/visa.png"; // Adjust path as needed
import checkOffImage from "../images/check-off.png"; // Adjust path as needed
import checkOnImage from "../images/check-on.png"; // Adjust path as needed

const CardItem = ({ card, onDelete, selected, onSelect, showdiscount, showDelete }) => {
  const isChecked = !!selected;
  
  // Determine card type from card number
  const getCardImage = (cardNumber) => {

    if (!cardNumber) return cardImgVisa; // default to visa
    const firstDigit = cardNumber.toString().charAt(0);
    const firstTwo = cardNumber.toString().substring(0, 2);
    const firstFour = cardNumber.toString().substring(0, 4);
    
    // Visa: starts with 4
    if (firstDigit === '4') {
      return cardImgVisa;
    }
    
    // Mastercard: starts with 51-55 or 2221-2720
    if (firstTwo >= '51' && firstTwo <= '55') {
      return cardImg;
    }
    if (firstFour >= '2221' && firstFour <= '2720') {
      return cardImg;
    }
    
    // Default to visa
    return cardImgVisa;
  };
  
  const cardImage = getCardImage(card.cardNumber);
  
  // Check if card is Mastercard
  const isMastercard = () => {
    if (!card.cardNumber) return false;
    const firstTwo = card.cardNumber.toString().substring(0, 2);
    const firstFour = card.cardNumber.toString().substring(0, 4);
    return (firstTwo >= '51' && firstTwo <= '55') || (firstFour >= '2221' && firstFour <= '2720');
  };
  
  return (
  <div className="card-item" style={{
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "12px",
    border: "1px solid #eee",
    borderRadius: "8px",
    marginBottom: "12px",
    marginRight:"16px",
    marginLeft:"16px",
    marginTop:"16px",
    background: "#fff",
    position: "relative"
  
  }}>
  
  {!showdiscount ? (
     <img src={selected ? checkOnImage : checkOffImage} alt="Card" onClick={() => onSelect && onSelect(card.cardNumber)}  style={{ width: "24px", height: "24px" }}/>
  ) : null}

    <img src={cardImage} alt="Credit Card" style={{ width: "36px", height: "24px" }} />
    
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: "bold" }}>{card.cardNumber}</div>
      <div style={{ fontSize: "0.9em", color: "#888" }}>Expiry: {card.expiryDate}</div>
      {showdiscount && isMastercard() && (
        <div style={{ marginTop: "7px", color: "#4caf50", fontWeight: "bold", fontSize: "0.5em" }}>
          🎉 You have a 5% cashback available with this card!
        </div>
      )}
    </div>
    {showDelete ? (
      <button
        onClick={() => onDelete(card.card_id)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "1.2em",
          color: "#d32f2f",
          marginLeft: "auto"
        }}
        title="Delete card"
        aria-label="Delete card"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="3 6 5 6 21 6"/>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>
          <line x1="10" y1="11" x2="10" y2="17"/>
          <line x1="14" y1="11" x2="14" y2="17"/>
        </svg>
      </button>
    ) : (
     showdiscount && <img src={selected ? checkOnImage : checkOffImage} alt="Card" onClick={() => onSelect && onSelect(card.cardNumber)}  style={{ width: "24px", height: "24px" }}/>
    )}
  </div>
  );
};

export default CardItem;